import React from 'react'
// import Slider from "react-slick";
import { Container, Col, Row } from 'react-bootstrap'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Vehicle4 from '../assets/images/vehicle-4.svg'
import Vehicle6 from '../assets/images/vehicle-6.svg'
import Vehicle7 from '../assets/images/vehicle-7.svg'
import Vehicle8 from '../assets/images/vehicle-8.svg'
import Vehicle9 from '../assets/images/road-roller.svg'
import Vehicle10 from '../assets/images/concrete-mixer.svg'
import Vehicle11 from '../assets/images/concrete-vibrator.svg'
import Vehicle12 from '../assets/images/grader-machine.svg'
import Vehicle13 from '../assets/images/level-machine.svg'
import Vehicle14 from '../assets/images/own-rmc-plant.svg'
import Vehicle15 from '../assets/images/pilling-jack.svg'
import Vehicle16 from '../assets/images/shuttering-materials.svg'
import Vehicle17 from '../assets/images/tractor-drilling-machine.svg'
import NewMachine from '../assets/images/newMachine.png';


const Machinery = () => {
    // var settings = {
    //     dots: false,
    //     infinite: true,
    //     speed: 1000,
    //     arrows: false,
    //     slidesToShow: 5,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     slidesToScroll: 1,
    //     responsive: [
    //         {
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 3,
    //                 infinite: true,
    //                 dots: true
    //             }
    //         },
    //         {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 2,
    //                 initialSlide: 2
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1
    //             }
    //         }
    //     ]
    // };
    return (<section >
        <Container>
            <Row className='align-items-center d-flex justify-content-center'>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle4} alt="Transit Mixer" className="img-fluid" />
                        <div className="count">
                            <h4><span>14</span> Transit Mixer</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle6} alt="Excavator" className="img-fluid" />
                        <div className="count">
                            <h4><span>2</span> Excavator 140</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle7} alt="Tractor With Trolley" className="img-fluid" />
                        <div className="count">
                            <h4><span>6</span> Tractor With Trolley & Water Tanker</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle8} alt="JCB" className="img-fluid" />
                        <div className="count">
                            <h4><span>5</span> JCB</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle10} alt="Concrete Mixer" className="img-fluid" />
                        <div className="count">
                            <h4><span>3</span> Self Loading Concrete Mixer </h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle13} alt="Level Machine" className="img-fluid" />
                        <div className="count">
                            <h4><span>2</span> Level Machine</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle16} alt="Shuttering Materials" className="img-fluid" />
                        <div className="count">
                            <h4><span>8000 Sqft.</span> Shuttering Materials </h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle11} alt="Concrete Vibrator" className="img-fluid" />
                        <div className="count">
                            <h4><span>3</span> Concrete Vibrator</h4>
                        </div>
                    </div>
                </Col>

                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle14} alt="Own RMC Plant" className="img-fluid" />
                        <div className="count">
                            <h4><span>2</span> Own RMC Plant with 45 & 60m³/hr Capacity</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle12} alt="Grader Machine" className="img-fluid" />
                        <div className="count">
                            <h4><span>2</span> Grader Machine</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle9} alt="6 to 10 Ton Roller" className="img-fluid" />
                        <div className="count">
                            <h4><span>4</span> 6 to 10 Ton Roller</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle17} alt="JCB Backhoe Loader" className="img-fluid" />
                        <div className="count">
                            <h4><span>6</span> Tractor Auguring Machine</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={Vehicle15} alt="MMS Pilling Jack" className="img-fluid" />
                        <div className="count">
                            <h4><span>4000 NOs</span> MMS Pilling Jack</h4>
                        </div>
                    </div>
                </Col>
                <Col md={6} lg={3} className='align-items-center d-flex justify-content-center'>
                    <div className="machinery">
                        <img src={NewMachine} alt="escort farana crane	" className="img-fluid" />
                        <div className="count">
                            <h4><span>2</span> Escort farana crane</h4>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
    )
}

export default Machinery


// <div className="text-center">
//     <Slider {...settings}>
//     </Slider>
// </div>